module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/community_newsletter_icon-58c5f5c8a206ed2e2d641a39b3aa5d26.png";